import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, actionPrefixes } from "@newsela/snitch";
import getButtonProps from "../utils/getButtonProps";
import useEventProperties from "../utils/useEventProperties";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  annotationId: PropTypes.number,
  buttonFlavor: PropTypes.string,
  buttonStatusColor: PropTypes.string,
  commentDeleteButtonRef: PropTypes.object,
  isActionPending: PropTypes.bool,
  handleDelete: PropTypes.func,
  isAComment: PropTypes.bool,
  shouldShowDeleteConfirmation: PropTypes.bool,
};

const DeleteButton = ({
  annotationId,
  buttonFlavor,
  commentDeleteButtonRef,
  isActionPending,
  handleDelete,
  isAComment,
  shouldShowDeleteConfirmation,
}) => {
  const description = isAComment
    ? "Delete annotation comment"
    : "Delete annotation";
  const eventProperties = useEventProperties(
    annotationId,
    actionNames.delete,
    description,
    actionPrefixes.initiate,
  );

  return (
    <ButtonWithTrackEvent
      disabled={shouldShowDeleteConfirmation || isActionPending}
      onClick={handleDelete}
      ref={commentDeleteButtonRef}
      {...getButtonProps(buttonFlavor)}
      {...eventProperties}
    >
      Delete
    </ButtonWithTrackEvent>
  );
};

DeleteButton.propTypes = propTypes;

export default DeleteButton;
